var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDbTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFA944",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2978 26.2999H23.9728C23.361 26.2999 22.8645 25.8082 22.8645 25.1999V21.8999C22.8645 21.2916 23.361 20.7999 23.9728 20.7999C24.5846 20.7999 25.0812 21.2916 25.0812 21.8999V24.0999H27.2978C27.9096 24.0999 28.4062 24.5916 28.4062 25.1999C28.4062 25.8082 27.9096 26.2999 27.2978 26.2999ZM25.07 15.3638C25.0723 15.3407 25.0833 15.3231 25.0833 15.3V14.2H26.1917C26.8035 14.2 27.3 13.7083 27.3 13.1C27.3 12.4917 26.8035 12 26.1917 12H21.7583C21.1465 12 20.65 12.4917 20.65 13.1C20.65 13.7083 21.1465 14.2 21.7583 14.2H22.8667V15.3C22.8667 15.3231 22.8778 15.3407 22.88 15.3638C17.8936 15.9072 14 20.1092 14 25.2C14 30.6593 18.4755 35.1 23.975 35.1C29.4746 35.1 33.95 30.6593 33.95 25.2C33.95 20.1092 30.0564 15.9072 25.07 15.3638Z",
    fill: "#FE7762"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDbTimer);
export default __webpack_public_path__ + "static/media/icon-db-timer.450ec5206a9bcf6e2fce16db1e2d9a99.svg";
export { ForwardRef as ReactComponent };